import type { ReactNode } from "react";
import { useIntl } from "react-intl";

type Props = {
  label: ReactNode;
  value: ReactNode;
};

export const PaymentDetailsSummaryRow = ({ label, value }: Props) => {
  const intl = useIntl();

  return (
    <div className="flex items-center justify-between gap-4 text-text-primary">
      <div>
        <div className="text-sm font-semibold">{label}</div>
        <div className="text-xs text-text-placeholder">
          {intl.formatMessage({
            defaultMessage: "Include taxes and charges",
            description: "Price summary price description",
          })}
        </div>
      </div>

      <div className="text-lg font-semibold">{value}</div>
    </div>
  );
};
